import { OFFER_COACH_DOCUMENTS_URL } from "../../helpers/api.routes";
import { requests } from "../../helpers/api.services";

export const OfferCoachDocumentService = {
  getAll: (params: any) => requests.get(`${OFFER_COACH_DOCUMENTS_URL}`, params),
};
